import { dew as _AbstractParserWithWordBoundaryDew } from "../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _casualReferencesDew } from "../../../common/casualReferences";
import { dew as _dayjsDew } from "../../../utils/dayjs";
import * as _dayjs3 from "dayjs";
var _dayjs2 = "default" in _dayjs3 ? _dayjs3.default : _dayjs3;
import { dew as _constantsDew } from "../constants";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
      enumerable: true,
      get: function () {
        return m[k];
      }
    });
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const references = __importStar(_casualReferencesDew());
  const dayjs_1 = _dayjsDew();
  const dayjs_2 = __importDefault(_dayjs2);
  const constants_1 = _constantsDew();
  const PATTERN = new RegExp(`(сейчас|прошлым\\s*вечером|прошлой\\s*ночью|следующей\\s*ночью|сегодня\\s*ночью|этой\\s*ночью|ночью|этим утром|утром|утра|в\\s*полдень|вечером|вечера|в\\s*полночь)` + `${constants_1.REGEX_PARTS.rightBoundary}`, constants_1.REGEX_PARTS.flags);
  class RUCasualTimeParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    patternLeftBoundary() {
      return constants_1.REGEX_PARTS.leftBoundary;
    }
    innerPattern() {
      return PATTERN;
    }
    innerExtract(context, match) {
      let targetDate = dayjs_2.default(context.refDate);
      const lowerText = match[0].toLowerCase();
      const component = context.createParsingComponents();
      if (lowerText === "\u0441\u0435\u0439\u0447\u0430\u0441") {
        return references.now(context.reference);
      }
      if (lowerText === "\u0432\u0435\u0447\u0435\u0440\u043E\u043C" || lowerText === "\u0432\u0435\u0447\u0435\u0440\u0430") {
        return references.evening(context.reference);
      }
      if (lowerText.endsWith("\u0443\u0442\u0440\u043E\u043C") || lowerText.endsWith("\u0443\u0442\u0440\u0430")) {
        return references.morning(context.reference);
      }
      if (lowerText.match(/в\s*полдень/)) {
        return references.noon(context.reference);
      }
      if (lowerText.match(/прошлой\s*ночью/)) {
        return references.lastNight(context.reference);
      }
      if (lowerText.match(/прошлым\s*вечером/)) {
        return references.yesterdayEvening(context.reference);
      }
      if (lowerText.match(/следующей\s*ночью/)) {
        const daysToAdd = targetDate.hour() < 22 ? 1 : 2;
        targetDate = targetDate.add(daysToAdd, "day");
        dayjs_1.assignSimilarDate(component, targetDate);
        component.imply("hour", 0);
      }
      if (lowerText.match(/в\s*полночь/) || lowerText.endsWith("\u043D\u043E\u0447\u044C\u044E")) {
        return references.midnight(context.reference);
      }
      return component;
    }
  }
  exports.default = RUCasualTimeParser;
  //# sourceMappingURL=RUCasualTimeParser.js.map
  return exports;
}